import React, {useEffect, useState} from 'react'
import {NavLink} from "react-router-dom";
import './FavoritesUsers.css'
import {useSelector} from "react-redux";
import {USER_PROFILE} from "../../types/models/profile";
import {apiProfilesFavorites} from "../../actions/profileActions";
import Loader from "../../components/ui/Loader/Loader";
import User from "../Users/components/User";
import { ROUTES } from '../../types/enum';

export function FavoritesUsers() {

  const activeType = useSelector(state => state.user.activeType)
  const token = useSelector(state => state.user.token)

  const [peoples, setPeoples] = useState<USER_PROFILE[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    loadUsers()
  }, [activeType])

  const loadUsers = async () => {

    if (token && activeType) {
      setLoading(true)
      const response = await apiProfilesFavorites(token, activeType)
      setPeoples(response)
      setLoading(false)
    }

  }

  return (
    <div className="users-wrapper">
      <div className="container">
        <div className="page-with-menu-top">
          <NavLink to={ROUTES.SEARCH} className="page-with-menu-top-back-icon">
            <img src="/images/icons/common/angle-left-black.svg" alt=""/>
          </NavLink>
          <span className="page-with-menu-top-title">Favorites users</span>
        </div>
        {loading ? (
          <div className="users-loader">
            <Loader/>
          </div>
        ) : (
          <>
            {peoples.length === 0 ? (
              <div className="favorites-users-empty">
                <img src="/images/icons/common/favorites.svg" alt="" className="favorites-users-empty-icon"/>
                <span className="favorites-users-empty-title">You haven’t favorite users. </span>
                <span className="favorites-users-empty-text">To add a user to your favorite, press a star icon on his/her photo. </span>
                <NavLink to={ROUTES.PEOPLES} className="favorites-users-link profile-text-color">Search people</NavLink>
              </div>
            ) : (
              <div className="users">
                {peoples.map(people => {
                  return (
                    <div className="users-element">
                      <User profile={people}/>
                    </div>
                  )
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )

}
